import { Box, Skeleton, Text } from '@mantine/core';
import { i18nKeys, useTranslation } from 'locales';
import { AnalyticsCard } from 'modules/Analytics/components/AnalyticsCard';

import { CompanyLinesChart } from './CompanyLinesChart';
import { useCompanyColorOf, useCompanyNameOf, useConsolidation } from './consolidation';

const asPercentage = (value: number) => `${value} %`;

type GroupCeiProps = { selectedCompanies: ReadonlyArray<string> };

export const GroupCei = ({ selectedCompanies }: GroupCeiProps) => {
  const { t } = useTranslation();
  const companyNameOf = useCompanyNameOf();
  const companyColorOf = useCompanyColorOf();
  const { groupAnalytics, groupAnalyticsError, isGroupAnalyticsLoading } =
    useConsolidation(selectedCompanies);

  if (groupAnalyticsError)
    return (
      <AnalyticsCard title={t(i18nKeys.ANALYTICS.CEI.TITLE)} panelProps={{ pb: 'space6' }}>
        <Text>{t(i18nKeys.GROUP.ANALYTICS_UNAVAILABLE)}</Text>
      </AnalyticsCard>
    );
  if (isGroupAnalyticsLoading)
    return (
      <AnalyticsCard title={t(i18nKeys.ANALYTICS.CEI.TITLE)} panelProps={{ pb: 'space6' }}>
        <Skeleton h={400} mt="md" radius={8} aria-busy />
      </AnalyticsCard>
    );
  if (!groupAnalytics) return null;

  return (
    <AnalyticsCard title={t(i18nKeys.ANALYTICS.CEI.TITLE)} panelProps={{ pb: 'space6' }}>
      <Box w="100%" h="400px">
        <CompanyLinesChart
          legendTarget="#cei-legend-outlet"
          formatValue={asPercentage}
          yAxis={{ max: 100, format: asPercentage }}
          lines={groupAnalytics.companyCeis.map(({ company, months }) => ({
            company,
            name: companyNameOf(company),
            color: companyColorOf(company),
            months,
          }))}
        />
      </Box>
      <Box id="cei-legend-outlet" />
    </AnalyticsCard>
  );
};
